import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import home from '../views/home/index.vue'
import course from '../views/course/index.vue'
import production from '../views/production/index.vue'
import team from '../views/team/index.vue'
import news from '../views/news/index.vue'
import newsdetals from '../views/news/details.vue'
import coursedetals from '../views/course/details.vue'
import profile from '../views/profile/index.vue'
import player from '../views/player/index.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: "*",
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/course',
    name: 'course',
    component: course
  },
  {
    path: '/production',
    name: 'production',
    component: production
  },
  {
    path: '/team',
    name: 'team',
    component: team
  },
  {
    path: '/news',
    name: 'news',
    component: news
  },
  {
    path: '/newsdetals',
    name: 'newsdetals',
    component: newsdetals
  },
  {
    path: '/coursedetals',
    name: 'coursedetals',
    component: coursedetals
  },
  {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: { requiresAuth: true } // 需要登录才能访问
  },
  {
    path: '/player',
    name: 'player',
    component: player,
    // 播放器页允许未登录进入，页面内自行处理登录弹窗与继续播放
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由错误处理
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

// 路由守卫，检查登录状态
router.beforeEach((to, from, next) => {
  // 注意：这里不能直接使用store，因为此时可能还没有Vue实例
  const userToken = localStorage.getItem('userToken');
  const isLoggedIn = !!userToken;
  
  console.log('路由守卫检查:', {
    to: to.path,
    isLoggedIn,
    hasToken: !!userToken,
    requiresAuth: to.matched.some(record => record.meta.requiresAuth)
  });
  
  // 如果路由需要登录且用户未登录
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    console.log('用户未登录，重定向到首页');
    // 重定向到首页，App.vue会检测到这个情况并显示登录弹窗
    next('/home');
  } else {
    next();
  }
});

export default router
